import { CellClassParams, CellStyle } from 'ag-grid-community';
import { PnlGridRow } from 'src/components/star-grid/starGridTypes';

const AXIS_INDENT_WIDTH = 12;
const AXIS_LABEL_PADDING = 8;
const AXIS_SPACER_HEIGHT = 20;
const AXIS_HEADER_PADDING = 10;

export const pnlAxisRowClass = (row?: PnlGridRow): string | undefined =>
  row?.axis_kind === 'header' ? 'sg-pnl-axis-header' : row?.axis_kind === 'spacer' ? 'sg-pnl-axis-spacer' : undefined;

export const pnlAxisRowHeight = (row: PnlGridRow | undefined, height: number): number | undefined => {
  if (!row?.axis_kind) return undefined;
  if (row.axis_kind === 'spacer') return AXIS_SPACER_HEIGHT;
  return row.axis_kind === 'header' ? height + AXIS_HEADER_PADDING : height;
};

export const pnlAxisLabelStyle = ({ data }: CellClassParams<PnlGridRow>): CellStyle | undefined =>
  typeof data?.axis_indent === 'number' ? { paddingLeft: `${AXIS_LABEL_PADDING + Math.max(0, data.axis_indent) * AXIS_INDENT_WIDTH}px` } : undefined;
